export default "__VITE_PUBLIC_ASSET__c727c237__"